import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControlLabel from '@mui/material/FormControlLabel';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import MotifResolutionSelect from './MotifResolutionSelect';
import CausePrincipaleSelect from './CausePrincipaleSelect';
import CausePrincipaleDetailSelect from './CausePrincipaleDetailSelect';
import UtilisateurSearch from 'components/Shared/UtilisateurSearch';
import DropZone from 'components/Shared/DropZone';

import { ReclamationClotureErrorCodes, MotifResolutionCodes } from 'constants.js';


import ClotureButton from './ClotureButton';

const styles = theme => ({
    formControl: {
        marginTop: '20px',
        marginBottom: '20px',
        width: '100%'
    },
    dialogPaper: {
        maxHeight: '90vh'
    },
    message: {
        marginTop: '8px',
        color: theme.palette.secondary.main
    }
});

class ClotureDialog extends React.Component {

    constructor(props) {
        super(props);

        // Initialisation du state.
        this.state = {
            motifResolutionId: 0
        };
    }

    checkErrors(motifResolutionId, causePrincipaleId) {
        let errors = [];

        if (motifResolutionId === 0) {
            errors.push({ key: ReclamationClotureErrorCodes.MotifResolution, errorMsg: 'Le motif de résolution est obligatoire.' });
        } else {
            errors.push({ key: ReclamationClotureErrorCodes.MotifResolution, errorMsg: null });
        }

        if (causePrincipaleId === 0) {
            errors.push({ key: ReclamationClotureErrorCodes.CausePrincipale, errorMsg: 'La cause principale est obligatoire.' });
        } else {
            errors.push({ key: ReclamationClotureErrorCodes.CausePrincipale, errorMsg: null });
        }

        return errors;
    }

    handleChange = (event) => {
        const { onChange, cloture } = this.props;

        const errors = this.checkErrors(cloture.motifResolutionId, cloture.causePrincipaleId);

        onChange(event, errors);
    }

    handleChangeMotifResolution = (event) => {
        const { onMotifResolutionChange, cloture } = this.props;

        const errors = this.checkErrors(event.target.value, cloture.causePrincipaleId);

        onMotifResolutionChange(event, errors);
    }

    handleChangeCausePrincipale = (event) => {
        const { onCausePrincipaleChange, cloture } = this.props;

        const errors = this.checkErrors(cloture.motifResolutionId, event.target.value);

        onCausePrincipaleChange(event, errors);
    }

    handleChangeUtilisateur = (id, codePO, nom, prenom) => {
        const { onUtilisateurChange, cloture } = this.props;

        const errors = this.checkErrors(cloture.motifResolutionId, cloture.causePrincipaleId);

        onUtilisateurChange(id, codePO, nom, prenom, errors);
    }

    handleQualificationDetailsNotifierSupport = (event) => {
        const { onNotifierSupport } = this.props;

        onNotifierSupport(event.target.value === 'true' ? true : false);
    }

    render() {
        const { classes, onClose, onClickSave, reclamationId, cloture, validationErrors, canCloture, namespace,
            motifsResolutionMessage, motifsResolution, causesPrincipales, causePrincipaleDetails, isQualiteEntrepot } = this.props;

        let motifResolutionError = validationErrors.find(e => e.key === ReclamationClotureErrorCodes.MotifResolution);
        let causePrincipaleError = validationErrors.find(e => e.key === ReclamationClotureErrorCodes.CausePrincipale);
        let causePrincipaleDetailError = validationErrors.find(e => e.key === ReclamationClotureErrorCodes.CausePrincipaleDetail);

        let motifAvoirClientSansRetour = motifsResolution.find(e => e.code === MotifResolutionCodes.AvoirClientSansRetour);

        return (
            <Dialog
                fullWidth
                open
                maxWidth={'md'}
                classes={{ paper: classes.dialogPaper }}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onClose(event, reason)
                    }
                }}
            >
                <DialogTitle>
                    Clôture du dossier après-vente {reclamationId}
                </DialogTitle>

                <DialogContent>
                    <div className={classes.formControl}>
                        <MotifResolutionSelect value={cloture.motifResolutionId}
                            error={motifResolutionError}
                            onChange={this.handleChangeMotifResolution}
                            motifsResolution={motifsResolution}
                        />

                        <Typography className={classes.message} variant="caption">
                            {motifsResolutionMessage}
                        </Typography>
                    </div>

                    <div className={classes.formControl}>
                        <CausePrincipaleSelect value={cloture.causePrincipaleId}
                            error={causePrincipaleError}
                            onChange={this.handleChangeCausePrincipale}
                            causesPrincipales={causesPrincipales}
                        />
                    </div>

                    {
                        causePrincipaleDetails && causePrincipaleDetails.length > 0 && (
                            <div className={classes.formControl}>
                                <CausePrincipaleDetailSelect value={cloture.causePrincipaleDetailId}
                                    error={causePrincipaleDetailError}
                                    onChange={this.handleChange}
                                    causePrincipaleDetails={causePrincipaleDetails}
                                />
                            </div>
                        )
                    }


                    <div className={classes.formControl}>
                        <UtilisateurSearch namespace={namespace}
                            onChange={this.handleChangeUtilisateur}
                            isRequired={false}
                            error={undefined}
                        />
                    </div>

                    <div className={classes.formControl}>
                        <TextField
                            multiline
                            fullWidth
                            id="commentaire"
                            name="commentaire"
                            label="Commentaire"
                            placeholder="Commentaire"
                            value={cloture.commentaire}
                            onChange={this.handleChange}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </div>

                    {
                        isQualiteEntrepot && motifAvoirClientSansRetour && cloture.motifResolutionId === motifAvoirClientSansRetour.id &&
                        <div className={classes.formControl}>
                            <Paper sx={{ p: 2 }}>
                                <Typography >Notifier support.informatique@foussier.fr</Typography>

                                <RadioGroup
                                    row
                                    id={'notifierSupport'}
                                    name={'notifierSupport'}
                                    className={classes.group}
                                    value={cloture.notifierSupport}
                                    onChange={this.handleQualificationDetailsNotifierSupport}
                                >
                                    <FormControlLabel value={'true'} control={<Radio />} label={'Oui'} />
                                    <FormControlLabel value={'false'} control={<Radio />} label={'Non'} />
                                </RadioGroup>
                            </Paper>
                        </div>
                    }
                    {
                        cloture.mailAutomatique.length > 0 &&
                        <div className={classes.formControl}>
                            <TextField
                                multiline
                                fullWidth
                                id="mailAutomatique"
                                name="mailAutomatique"
                                label="Mail"
                                placeholder="Mail"
                                maxRows="5"
                                value={cloture.mailAutomatique}
                                onChange={this.handleChange}
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                        </div>
                    }



                    <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />

                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose} color="primary">Annuler</Button>
                    <ClotureButton
                        onClick={onClickSave}
                        canCloture={canCloture}
                    />
                </DialogActions>

            </Dialog >
        );
    }
}

ClotureDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    reclamationId: PropTypes.number.isRequired,
    cloture: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onMotifResolutionChange: PropTypes.func.isRequired,
    onCausePrincipaleChange: PropTypes.func.isRequired,
    onUtilisateurChange: PropTypes.func.isRequired,
    onClickSave: PropTypes.func.isRequired,
    validationErrors: PropTypes.array.isRequired,
    canCloture: PropTypes.bool.isRequired,
    namespace: PropTypes.string.isRequired,
    motifsResolutionMessage: PropTypes.string
};


export default withStyles(styles)(ClotureDialog);

